"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rolEchainWithoutAdditionalLinkMock = exports.rolEchainWithModifiedLinkMock = exports.rolEchainWithAutoglideLinkMock = exports.rolEchainWithAdapterLink2828RMock = void 0;
const ArticleSpecs_1 = require("../ArticleSpecs");
const echain_product_models_1 = require("@igus/echain-product-models");
const KettenSerieModel_1 = require("../kette/KettenSerieModel");
const KetteSerieType_1 = require("../kette/KetteSerieType");
const LinkType_1 = require("../link/LinkType");
const KetteEinspeisung_1 = require("../kette/KetteEinspeisung");
const KetteBauform_1 = require("../kette/KetteBauform");
const fuehrungsrinne_typ_1 = require("../fuehrungsrinne/fuehrungsrinne-typ");
exports.rolEchainWithAdapterLink2828RMock = {
    RolLinkRef: '2828R.06.220.S10.0.E',
    StandardLinkRef: '2828B.06.220.0',
    AdapterLinkRef: '2828R.0.220.0',
    ArtNr: {
        DE: '2828R.05.125.S10.0.E',
    },
    Id: 9234529525,
    ArticleType: echain_product_models_1.ArticleType.kette,
    Bauform: KetteBauform_1.KetteBauform.kette,
    Bezeichnung: {
        'de-DE': 'igus® Rollenkettenglied 2828R',
        'en-GB': 'roll E-Chain link Series 2828R',
        'it-IT': 'roll maglia catena serie 2828R',
        'nl-NL': 'igus® Rollenkettenglied 2828R',
        'pt-BR': 'Calha articulada igus série 2828R',
        'pt-PT': 'Calha articulada igus série 2828R',
    },
    LangerWegZeichnungsnummer: '27371',
    BestTyp: 400,
    SerieRef: {
        Id: 9180542665,
        Kuerzel: '2828R',
    },
    SerienKurzbezeichnung: 'Serie_2828R',
    IndexBreite: '06',
    IndexBiegeradius: '220',
    NumFirstOtherLinks: 3,
    Halbstegig: false,
    VersatzFestpunktErlaubt: true,
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: true,
    FreigabeEIC: false,
    FreigabeEKE: true,
    FreigabeEKEManualMode: false,
    FreigabeEIQ: true,
    KetteSerieType: KetteSerieType_1.KetteSerieType.rolEchain,
    ApproxVerfahrwegToEffektiveLaenge: [
        [10, 6.279],
        [50, 26.299],
        [100, 51.233],
    ],
    BelastungGleitendMaxWeightUntilSpeed: [
        [10, 1],
        [5, 2],
        [3.3000000000000003, 3],
        [2.5, 4],
        [1, 2],
    ],
    BeschleunigungGleitendMax: {
        Value: 50,
        Unit: 'm_s2',
    },
    BeschleunigungGleitendMax_m_s2: 50,
    FZGleitendMax: {
        Value: 10,
        Unit: 'kg_m',
    },
    GeschwindigkeitGleitendMax: {
        Value: 10,
        Unit: 'm_s',
    },
    GeschwindigkeitGleitendMax_m_s: 10,
    H: {
        Value: 494,
        Unit: 'mm',
    },
    H_mm: 494,
    HoeheVorspannung: {
        Value: 40,
        Unit: 'mm',
    },
    HoeheVorspannung_mm: 40,
    MaxAELaenge: {
        Value: 154,
        Unit: 'mm',
    },
    MaxAELaenge_mm: 154,
    MinBauraumGleitendRinneRefs: [
        {
            FuehrungsrinneId: 3094,
            FuehrungsrinneTyp: fuehrungsrinne_typ_1.FuehrungsrinneTyp.SuperAlu,
            FuehrungsrinneStuecklaenge: {
                Unit: 'mm',
                Value: 2000,
            },
            MontageSetId: 2533,
            Breite: {
                Unit: 'mm',
                Value: 184,
            },
            Hoehe: {
                Unit: 'mm',
                Value: 564,
            },
        },
        {
            FuehrungsrinneId: 3094,
            FuehrungsrinneTyp: fuehrungsrinne_typ_1.FuehrungsrinneTyp.SuperAlu,
            FuehrungsrinneStuecklaenge: {
                Unit: 'mm',
                Value: 2000,
            },
            MontageSetId: 7705,
            Breite: {
                Unit: 'mm',
                Value: 190,
            },
            Hoehe: {
                Unit: 'mm',
                Value: 564,
            },
        },
        {
            FuehrungsrinneId: 7720,
            FuehrungsrinneTyp: fuehrungsrinne_typ_1.FuehrungsrinneTyp.Stahl,
            FuehrungsrinneStuecklaenge: {
                Unit: 'mm',
                Value: 2000,
            },
            MontageSetId: 3624,
            Breite: {
                Unit: 'mm',
                Value: 209,
            },
            Hoehe: {
                Unit: 'mm',
                Value: 554,
            },
        },
    ],
    MontagesetRef: [2533, 3119, 3126, 7705, 3624, 2538, 7719],
    RinneRef: [7721, 7720, 3094, 7695],
    RinnenvarianteRef: [
        {
            Name: 'FRV Führungsrinne "Super-Alu", "Basic"',
            RinneRef: [3094, 7695],
            MontagesetRef: [2532, 2534, 2533, 2535, 2536, 2537, 2538, 3096, 3098, 3097, 7696, 7698, 7697, 7699, 7700, 7701],
        },
        {
            Name: 'FRV Führungsrinne "Super-Alu", "Heavy Duty"',
            RinneRef: [3094, 7695],
            MontagesetRef: [7715, 7716, 7717, 7714, 7713, 7710, 7712, 7711, 7708, 7709, 7706, 7707, 7705, 7704, 7719, 37184],
        },
        {
            Name: 'FRV Führungsrinnen aus Stahl',
            RinneRef: [7720, 7721],
            MontagesetRef: [3624, 3623, 7723, 7722, 7724, 7725, 3625, 3626, 3627],
        },
        {
            Name: 'ARNV Ablegerinne Typ 01',
            RinneRef: [
                52396, 54963, 54962, 54961, 54960, 54959, 54958, 54957, 54956, 54952, 54951, 54950, 54949, 54947, 54946, 52397,
            ],
            MontagesetRef: [54955, 54954, 54953, 54948],
        },
    ],
    Biegeradius: {
        Value: 220,
        Unit: 'mm',
    },
    Biegeradius_mm: 220,
    Aussenbreite: {
        Value: 92,
        Unit: 'mm',
    },
    Aussenbreite_mm: 92,
    Aussenhoehe: {
        Value: 54,
        Unit: 'mm',
    },
    Aussenhoehe_mm: 54,
    Innenbreite: {
        Value: 68,
        Unit: 'mm',
    },
    Innenbreite_mm: 68,
    Innenhoehe: {
        Value: 32,
        Unit: 'mm',
    },
    Innenhoehe_mm: 32,
    LeitungDiameterMax: {
        Value: 28,
        Unit: 'mm',
    },
    LeitungDiameterMax_mm: 28,
    TemperaturMin: {
        Value: -40,
        Unit: '°C',
    },
    TemperaturMin_C: -40,
    TemperaturMax: {
        Value: 120,
        Unit: '°C',
    },
    TemperaturMax_C: 120,
    GewichtKgProM: {
        Value: 1.8028571428571427,
        Unit: 'kg_m',
    },
    GewichtKgProM_kg_m: 1.8028571428571427,
    K2: {
        Value: 1624,
        Unit: 'mm',
    },
    K2_mm: 1624,
    X1: {
        Value: 400,
        Unit: 'mm',
    },
    X1_mm: 400,
    D1: {
        Value: 175,
        Unit: 'mm',
    },
    D1_mm: 175,
    EntityId: '1',
    Verfahrweg: { Value: 63400, Unit: 'mm' },
    Verfahrweg_mm: 63400,
    NumGlieder: 549,
    EffektiveLaenge: { Value: 33376, Unit: 'mm' },
    LangerWeg: true,
    Einspeisung: KetteEinspeisung_1.KetteEinspeisung.mittigeEinspeisung,
    Versatz: { Value: 0, Unit: 'mm' },
    Versatz_mm: 0,
    BelastungFLG: [],
    BelastungFLB: [],
    PushPullForceMax: { Value: 6000, Unit: 'N' },
    PushPullForceMax_N: 6000,
    MinDistKlemmO: { Value: 1, Unit: 'mm' },
    MinDistKlemmU: { Value: 1, Unit: 'mm' },
    MinDistO: { Value: 1, Unit: 'mm' },
    MinDistU: { Value: 1, Unit: 'mm' },
    RastPosDist: { Value: 1, Unit: 'mm' },
    RastPosLeft: { Value: 1, Unit: 'mm' },
    StaticIAArtikelRef: [],
    IsMontageMitnehmer: false,
    RolLink: {
        ArtNr: { DE: '2828R.06.220.S10.0.E' },
        ArtNrExists: true,
        ArtNrGenerated: '2828R.06.220.S10.0.E',
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.rolEchainRolLink],
        ArticleType: echain_product_models_1.ArticleType.link,
        LinkType: LinkType_1.LinkType.RolLink,
        Aussenbreite: { Value: 92, Unit: 'mm' },
        Aussenhoehe: { Value: 54, Unit: 'mm' },
        BestTyp: 400,
        Bezeichnung: {
            'de-DE': 'igus® Rollenkettenglied 2828R',
            'en-GB': 'roll E-Chain link Series 2828R',
            'it-IT': 'roll maglia catena serie 2828R',
            'nl-NL': 'igus® Rollenkettenglied 2828R',
            'pt-BR': 'Calha articulada igus série 2828R',
            'pt-PT': 'Calha articulada igus série 2828R',
        },
        Biegeradius: { Value: 220, Unit: 'mm' },
        D1: { Value: 260, Unit: 'mm' },
        DataSource: 'stub',
        FreigabeEIQ: true,
        GleitenderBetriebErlaubt: true,
        Halbstegig: false,
        FreigabeEIC: false,
        FreigabeEKEManualMode: false,
        Id: 9207384756,
        IndexBiegeradius: '220',
        IndexBreite: '06',
        Innenbreite: { Value: 68, Unit: 'mm' },
        Innenhoehe: { Value: 32, Unit: 'mm' },
        IsMontageMitnehmer: false,
        K2: { Value: 1624, Unit: 'mm' },
        LangerWeg: false,
        LangerWegZeichnungsnummer: '27371',
        MinDistKlemmO: { Value: 0, Unit: 'mm' },
        MinDistKlemmU: { Value: 0, Unit: 'mm' },
        MinDistO: { Value: 0, Unit: 'mm' },
        MinDistU: { Value: 0, Unit: 'mm' },
        MontagesetRef: [],
        RastPosDist: { Value: 0, Unit: 'mm' },
        RastPosLeft: { Value: 0, Unit: 'mm' },
        RinneRef: [],
        StaticIAArtikelRef: [],
        Teilung: { Value: 112, Unit: 'mm' },
        UngeradeAnzahlGlieder: false,
        Versatz: { Value: 0, Unit: 'mm' },
        VersatzFestpunktErlaubt: true,
        WeightPerLink: { Value: 203, Unit: 'g' },
        X1: { Value: 780, Unit: 'mm' },
    },
    StandardLink: {
        ArtNr: { DE: '2828B.06.220.0', US: '2828-06-220-0' },
        ArtNrExists: true,
        ArtNrGenerated: '2828B.06.220.0',
        ArtSerieBreite: '2828.06',
        ArticleType: echain_product_models_1.ArticleType.link,
        // todo LinkType instead of ArticleSpecs [EKE-11146]
        KetteSerieType: KetteSerieType_1.KetteSerieType.default,
        LinkType: LinkType_1.LinkType.StandardLink,
        Aussenbreite: { Value: 91, Unit: 'mm' },
        Aussenhoehe: { Value: 54, Unit: 'mm' },
        BestTyp: 400,
        Bezeichnung: {
            'de-DE': 'e-kette® Classic Serie 2828B',
            'it-IT': 'Catena portacavi serie 2828',
            'fr-FR': 'Chaîne Série 2828',
            'es-ES': 'Cadena portacables serie 2828',
            'ja-JP': 'エナジーチェーン 2828型',
            'hu-HU': 'E-Chains® 2828 Széria',
            'ko-KR': 'E-Chain® 2828 시리즈',
            'en-US': 'Energy chain® Series 2828',
            'zh-TW': '2828系列拖鏈',
            'nl-NL': 'Kabelrups serie 2828',
            'pt-PT': 'Calhas articuladas da série 2828',
            'pl-PL': 'e-prowadniki serii 2828',
            'da-DK': 'E-Kæde -serie 2828',
            'sv-SE': 'E-kedja serie 2828',
            'en-GB': 'e-chain® classic series 2828B',
            'zh-CN': '2828系列拖链',
            'cs-CZ': 'e-chain® série 2828',
        },
        Biegeradius: { Value: 220, Unit: 'mm' },
        DataSource: 'ipro',
        FreigabeEIQ: true,
        FreitragenderBetriebErlaubt: true,
        GewichtKgProM: { Value: 1.79, Unit: 'kg_m' },
        GleitenderBetriebErlaubt: true,
        Halbstegig: false,
        FreigabeEIC: true,
        FreigabeEKEManualMode: true,
        Id: 8320,
        IndexBiegeradius: '220',
        IndexBreite: '06',
        Innenbreite: { Value: 68, Unit: 'mm' },
        Innenhoehe: { Value: 32, Unit: 'mm' },
        IproProduktgruppenId: 17,
        IsMontageMitnehmer: false,
        K: { Value: 805, Unit: 'mm' },
        K2: { Value: 1456, Unit: 'mm' },
        LangerWeg: false,
        LangerWegZeichnungsnummer: 'D00034101',
        LeitungDiameterMax: { Value: 28, Unit: 'mm' },
        MinDistKlemmO: { Value: 30, Unit: 'mm' },
        MinDistKlemmU: { Value: 30, Unit: 'mm' },
        MinDistO: { Value: 0, Unit: 'mm' },
        MinDistU: { Value: 0, Unit: 'mm' },
        MontagesetRef: [7705, 3126, 3119, 2533, 3624, 2538, 7719],
        RastPosDist: { Value: 5, Unit: 'mm' },
        RastPosLeft: { Value: 1, Unit: 'mm' },
        RinneRef: [7720, 7721, 3094, 7695],
        StandardTrennstegArtNr: '32.1.1',
        StaticIAArtikelRef: [],
        SerieRef: {
            Id: 8301,
            Kuerzel: '2828B',
        },
        Teilung: { Value: 56, Unit: 'mm' },
        UngeradeAnzahlGlieder: false,
        Versatz: { Value: 0, Unit: 'mm' },
        VersatzFestpunktErlaubt: true,
        WeightPerLink: { Unit: 'g', Value: 100.24 },
        X1: { Value: 260, Unit: 'mm' },
    },
    AdapterLink: {
        ArtNr: { DE: '2828R.06.220.0' },
        ArtNrExists: true,
        ArtNrGenerated: '2828R.06.220.0',
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.rolEchainAdapterLink],
        ArticleType: echain_product_models_1.ArticleType.link,
        LinkType: LinkType_1.LinkType.RolAdapterLink,
        Aussenbreite: { Value: 92, Unit: 'mm' },
        Aussenhoehe: { Value: 54, Unit: 'mm' },
        BestTyp: 400,
        Bezeichnung: {
            'de-DE': 'igus® Adapterkettenglied 2828R',
            'en-GB': 'igus e-chain series 2828R',
            'en-US': 'igus e-chain series 2828R',
        },
        Biegeradius: { Value: 220, Unit: 'mm' },
        DataSource: 'stub',
        FreigabeEIQ: true,
        GewichtKgProM: { Value: 1.8258, Unit: 'kg_m' },
        GleitenderBetriebErlaubt: true,
        Halbstegig: false,
        FreigabeEIC: false,
        FreigabeEKEManualMode: false,
        Id: 9169338465,
        IndexBiegeradius: '220',
        IndexBreite: '06',
        Innenbreite: { Value: 68, Unit: 'mm' },
        Innenhoehe: { Value: 32, Unit: 'mm' },
        IsMontageMitnehmer: false,
        LangerWeg: false,
        LangerWegZeichnungsnummer: '27371',
        MinDistKlemmO: { Value: 0, Unit: 'mm' },
        MinDistKlemmU: { Value: 0, Unit: 'mm' },
        MinDistO: { Value: 0, Unit: 'mm' },
        MinDistU: { Value: 0, Unit: 'mm' },
        MontagesetRef: [],
        RastPosDist: { Value: 0, Unit: 'mm' },
        RastPosLeft: { Value: 0, Unit: 'mm' },
        RinneRef: [],
        StaticIAArtikelRef: [],
        Teilung: { Value: 56, Unit: 'mm' },
        UngeradeAnzahlGlieder: false,
        Versatz: { Value: 0, Unit: 'mm' },
        VersatzFestpunktErlaubt: true,
        WeightPerLink: { Value: 103, Unit: 'g' },
    },
    Serie: {
        Grease: {
            ArtNr: { DE: 'MAT0020004', US: 'MAT0020004' },
            Description: {
                'de-DE': 'Schmierfett',
                'en-US': 'Lubricating grease',
                'en-GB': 'Lubricating grease',
            },
        },
        Id: 9180542665,
        KetteSerieType: KetteSerieType_1.KetteSerieType.rolEchain,
        Kuerzel: '2828R',
        LangerWegZeichnungsnummer: '27371',
        RolEchainParts: [
            { Name: KettenSerieModel_1.RolEchainPartNames.Part1a, NumKG: 13, NumRKG: 1, NumAKG: 1 },
            { Name: KettenSerieModel_1.RolEchainPartNames.Part1b, NumKG: 1, NumRKG: 1, NumAKG: 1 },
            { Name: KettenSerieModel_1.RolEchainPartNames.Part1c, NumKG: 1, NumRKG: 1, NumAKG: 1 },
            { Name: KettenSerieModel_1.RolEchainPartNames.Part1d, NumKG: 0, NumRKG: 0, NumAKG: 0 },
            { Name: KettenSerieModel_1.RolEchainPartNames.Part1e, NumKG: 0, NumRKG: 0, NumAKG: 0 },
            { Name: KettenSerieModel_1.RolEchainPartNames.Part2, NumKG: 9, NumRKG: 1, NumAKG: 1 },
            { Name: KettenSerieModel_1.RolEchainPartNames.Part3, NumKG: 10, NumRKG: 1, NumAKG: 1 },
        ],
    },
};
exports.rolEchainWithAutoglideLinkMock = {
    ArticleType: echain_product_models_1.ArticleType.kette,
    KetteSerieType: KetteSerieType_1.KetteSerieType.rolEchain,
    RolLinkRef: 'todo',
    StandardLinkRef: 'a.b.2.0',
    AutoglideLinkRef: 'a.b.3.0',
    NumFirstOtherLinks: 3,
    RolLink: {
        LinkType: LinkType_1.LinkType.RolLink,
        ArticleType: echain_product_models_1.ArticleType.link,
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.rolEchainRolLink],
        ArtNr: {
            DE: 'a.b.1.0',
        },
        ArtNrGenerated: 'a.b.1.0',
        Bezeichnung: {
            'de-DE': 'Rollenglied',
            'en-GB': 'rolLink',
        },
        LangerWeg: true,
        Teilung: { Value: 145, Unit: 'mm' },
        WeightPerLink: { Value: 198.38, Unit: 'g' },
        Innenhoehe: { Value: 1, Unit: 'mm' },
        Innenbreite: { Value: 1, Unit: 'mm' },
        IndexBiegeradius: '1',
        IndexBreite: '01',
        Aussenhoehe: { Value: 1, Unit: 'mm' },
        Aussenbreite: { Value: 1, Unit: 'mm' },
        K2: { Value: 2184, Unit: 'mm' },
        Id: 123456789,
    },
    StandardLink: {
        LinkType: LinkType_1.LinkType.StandardLink,
        ArticleType: echain_product_models_1.ArticleType.link,
        // todo LinkType instead of ArticleSpecs [EKE-11146]
        KetteSerieType: KetteSerieType_1.KetteSerieType.default,
        ArtNr: {
            DE: 'a.b.2.0',
        },
        Bezeichnung: {
            'de-DE': 'Standardglied',
            'en-GB': 'standardLink',
        },
        ArtNrGenerated: 'a.b.2.0',
        Innenhoehe: { Value: 2, Unit: 'mm' },
        Innenbreite: { Value: 2, Unit: 'mm' },
        Aussenhoehe: { Value: 2, Unit: 'mm' },
        Aussenbreite: { Value: 2, Unit: 'mm' },
        Teilung: { Value: 91, Unit: 'mm' },
        K2: { Value: 2184, Unit: 'mm' },
        WeightPerLink: { Value: 91.96, Unit: 'g' },
        Id: 987654321,
        Biegeradius: { Value: 300, Unit: 'mm' },
    },
    AutoglideLink: {
        LinkType: LinkType_1.LinkType.RolAutoglideLink,
        ArticleType: echain_product_models_1.ArticleType.link,
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.rolEchainAutoglideLink],
        ArtNr: {
            DE: 'a.b.3.0',
        },
        Bezeichnung: {
            'de-DE': 'Autoglideglied',
            'en-GB': 'autoglideLink',
        },
        Innenhoehe: { Value: 1, Unit: 'mm' },
        Innenbreite: { Value: 1, Unit: 'mm' },
        Aussenhoehe: { Value: 1, Unit: 'mm' },
        Aussenbreite: { Value: 1, Unit: 'mm' },
        Teilung: { Value: 91, Unit: 'mm' },
        WeightPerLink: { Value: 89.23, Unit: 'g' },
        Id: 9876,
    },
    Serie: {
        Id: 123,
        KetteSerieType: KetteSerieType_1.KetteSerieType.rolEchain,
        RolEchainCalcByFormula: KettenSerieModel_1.RolEchainCalculationFormulas.Default,
        LangerWegZeichnungsnummer: '12345',
        RolEchainParts: [
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part1a,
                NumKG: 13,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part1b,
                NumKG: 2,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part1c,
                NumKG: 2,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part2,
                NumKG: 6,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part3,
                NumKG: 7,
                NumRKG: 1,
                NumAKG: 0,
            },
        ],
    },
    Verfahrweg: { Value: 63400, Unit: 'mm' },
    Versatz: { Value: 0, Unit: 'mm' },
    ArtNr: {
        DE: 'TODO',
    },
    Id: 50000001,
    Bezeichnung: {},
    LangerWegZeichnungsnummer: '27371',
    BestTyp: 400,
    SerieRef: {
        Id: 9180542665,
        Kuerzel: 'TODO',
    },
    SerienKurzbezeichnung: 'Serie_TODO',
    IndexBreite: '05',
    IndexBiegeradius: '125',
    Halbstegig: false,
    VersatzFestpunktErlaubt: true,
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: true,
    FreigabeEIC: false,
    FreigabeEKE: true,
    FreigabeEKEManualMode: false,
    FreigabeEIQ: true,
    Aussenbreite: {
        Value: 74,
        Unit: 'mm',
    },
    Aussenbreite_mm: 74,
    Aussenhoehe: {
        Value: 54,
        Unit: 'mm',
    },
    Aussenhoehe_mm: 54,
    Bauform: KetteBauform_1.KetteBauform.kette,
    BelastungGleitendMaxWeightUntilSpeed: [[6, 1]],
    Biegeradius: {
        Value: 125,
        Unit: 'mm',
    },
    Biegeradius_mm: 125,
    FZGleitendMax: {
        Value: 6,
        Unit: 'kg_m',
    },
    H: {
        Value: 130,
        Unit: 'mm',
    },
    H_mm: 130,
    HoeheVorspannung: {
        Value: 130,
        Unit: 'mm',
    },
    HoeheVorspannung_mm: 130,
    Innenbreite: {
        Value: 50,
        Unit: 'mm',
    },
    Innenbreite_mm: 50,
    Innenhoehe: {
        Value: 32,
        Unit: 'mm',
    },
    Innenhoehe_mm: 32,
    K2: {
        Value: 896,
        Unit: 'mm',
    },
    K2_mm: 896,
    LeitungDiameterMax: {
        Value: 9,
        Unit: 'mm',
    },
    LeitungDiameterMax_mm: 9,
    TemperaturMin: {
        Value: -40,
        Unit: '°C',
    },
    TemperaturMin_C: -40,
    TemperaturMax: {
        Value: 120,
        Unit: '°C',
    },
    TemperaturMax_C: 120,
    X1: {
        Value: 400,
        Unit: 'mm',
    },
    X1_mm: 400,
    D1: {
        Value: 175,
        Unit: 'mm',
    },
    D1_mm: 175,
    BeschleunigungGleitendMax: {
        Value: 50,
        Unit: 'm_s2',
    },
    BeschleunigungGleitendMax_m_s2: 50,
    GeschwindigkeitGleitendMax: {
        Value: 10,
        Unit: 'm_s',
    },
    GeschwindigkeitGleitendMax_m_s: 10,
    MaxAELaenge: {
        Value: 154,
        Unit: 'mm',
    },
    MaxAELaenge_mm: 154,
    EntityId: '1',
    Verfahrweg_mm: 63400,
    RinneRef: [],
    MontagesetRef: [],
    LangerWeg: true,
    Einspeisung: KetteEinspeisung_1.KetteEinspeisung.mittigeEinspeisung,
    BelastungFLG: [],
    BelastungFLB: [],
    MinDistKlemmO: { Value: 1, Unit: 'mm' },
    MinDistKlemmU: { Value: 1, Unit: 'mm' },
    MinDistO: { Value: 1, Unit: 'mm' },
    MinDistU: { Value: 1, Unit: 'mm' },
    RastPosDist: { Value: 1, Unit: 'mm' },
    RastPosLeft: { Value: 1, Unit: 'mm' },
    StaticIAArtikelRef: [],
    MinBauraumGleitendRinneRefs: [],
    RinnenvarianteRef: [
        {
            Name: 'FRV Führungsrinne "Super-Alu", "Basic"',
            RinneRef: [3094, 7695],
            MontagesetRef: [2533, 2532, 2534, 2535, 2536, 3096, 2537, 2538, 3098, 3097, 7697, 7696, 7698, 7699, 7700, 7701],
        },
        {
            Name: 'FRV Führungsrinne "Super-Alu", "Heavy Duty"',
            RinneRef: [3094, 7695],
            MontagesetRef: [7704, 7706, 7705, 7707, 7708, 7709, 7710, 7711, 7712, 7713, 7714, 7715, 7716, 7717, 7719, 37184],
        },
        {
            Name: 'FRV Führungsrinnen aus Stahl',
            RinneRef: [7720, 7721],
            MontagesetRef: [3624, 3623, 3625, 3626, 7723, 7722, 3627, 7724, 7725],
        },
        {
            Name: 'ARNV Ablegerinne Typ 01',
            RinneRef: [
                52397, 52396, 54946, 54963, 54962, 54961, 54960, 54959, 54958, 54957, 54956, 54952, 54951, 54950, 54949, 54947,
            ],
            MontagesetRef: [54955, 54954, 54953, 54948],
        },
    ],
    IsMontageMitnehmer: false,
};
exports.rolEchainWithModifiedLinkMock = {
    ArticleType: echain_product_models_1.ArticleType.kette,
    KetteSerieType: KetteSerieType_1.KetteSerieType.rolEchain,
    RolLinkRef: 'todo',
    StandardLinkRef: 'a.b.2.0',
    ModifiedLinkRef: 'a.b.3.0',
    NumFirstOtherLinks: 3,
    RolLink: {
        LinkType: LinkType_1.LinkType.RolLink,
        ArticleType: echain_product_models_1.ArticleType.link,
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.rolEchainRolLink],
        ArtNr: {
            DE: 'a.b.1.0',
        },
        ArtNrGenerated: 'a.b.1.0',
        Bezeichnung: {
            'de-DE': 'Rollenglied',
            'en-GB': 'rolLink',
        },
        LangerWeg: true,
        Teilung: { Value: 145, Unit: 'mm' },
        WeightPerLink: { Value: 198.38, Unit: 'g' },
        Innenhoehe: { Value: 1, Unit: 'mm' },
        Innenbreite: { Value: 1, Unit: 'mm' },
        IndexBiegeradius: '1',
        IndexBreite: '01',
        Aussenhoehe: { Value: 1, Unit: 'mm' },
        Aussenbreite: { Value: 1, Unit: 'mm' },
        K2: { Value: 2184, Unit: 'mm' },
        Id: 123456789,
    },
    StandardLink: {
        LinkType: LinkType_1.LinkType.StandardLink,
        ArticleType: echain_product_models_1.ArticleType.link,
        // todo LinkType instead of ArticleSpecs [EKE-11146]
        KetteSerieType: KetteSerieType_1.KetteSerieType.default,
        ArtNr: {
            DE: 'a.b.2.0',
        },
        Bezeichnung: {
            'de-DE': 'Standardglied',
            'en-GB': 'standardLink',
        },
        ArtNrGenerated: 'a.b.2.0',
        Innenhoehe: { Value: 2, Unit: 'mm' },
        Innenbreite: { Value: 2, Unit: 'mm' },
        Aussenhoehe: { Value: 2, Unit: 'mm' },
        Aussenbreite: { Value: 2, Unit: 'mm' },
        Teilung: { Value: 91, Unit: 'mm' },
        K2: { Value: 2184, Unit: 'mm' },
        WeightPerLink: { Value: 91.96, Unit: 'g' },
        Id: 987654321,
        Biegeradius: { Value: 300, Unit: 'mm' },
    },
    ModifiedLink: {
        LinkType: LinkType_1.LinkType.RolModifiedLink,
        ArticleType: echain_product_models_1.ArticleType.link,
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.rolEchainModifiedLink],
        ArtNr: {
            DE: 'a.b.3.0',
        },
        Bezeichnung: {
            'de-DE': 'Modifiedglied',
            'en-GB': 'modifiedLink',
        },
        Innenhoehe: { Value: 1, Unit: 'mm' },
        Innenbreite: { Value: 1, Unit: 'mm' },
        Aussenhoehe: { Value: 1, Unit: 'mm' },
        Aussenbreite: { Value: 1, Unit: 'mm' },
        Teilung: { Value: 91, Unit: 'mm' },
        WeightPerLink: { Value: 89.23, Unit: 'g' },
        Id: 432144,
    },
    Serie: {
        Id: 123,
        KetteSerieType: KetteSerieType_1.KetteSerieType.rolEchain,
        RolEchainCalcByFormula: KettenSerieModel_1.RolEchainCalculationFormulas.Default,
        LangerWegZeichnungsnummer: '12345',
        RolEchainParts: [
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part1a,
                NumKG: 13,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part1b,
                NumKG: 2,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part1c,
                NumKG: 2,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part2,
                NumKG: 6,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part3,
                NumKG: 7,
                NumRKG: 1,
                NumAKG: 0,
            },
        ],
    },
    Verfahrweg: { Value: 63400, Unit: 'mm' },
    Versatz: { Value: 0, Unit: 'mm' },
    ArtNr: {
        DE: 'TODO',
    },
    Id: 50000001,
    Bezeichnung: {},
    LangerWegZeichnungsnummer: '27371',
    BestTyp: 400,
    SerieRef: {
        Id: 9180542665,
        Kuerzel: 'TODO',
    },
    SerienKurzbezeichnung: 'Serie_TODO',
    IndexBreite: '05',
    IndexBiegeradius: '125',
    Halbstegig: false,
    VersatzFestpunktErlaubt: true,
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: true,
    FreigabeEIC: false,
    FreigabeEKE: true,
    FreigabeEKEManualMode: false,
    FreigabeEIQ: true,
    Aussenbreite: {
        Value: 74,
        Unit: 'mm',
    },
    Aussenbreite_mm: 74,
    Aussenhoehe: {
        Value: 54,
        Unit: 'mm',
    },
    Aussenhoehe_mm: 54,
    Bauform: KetteBauform_1.KetteBauform.kette,
    BelastungGleitendMaxWeightUntilSpeed: [[6, 1]],
    Biegeradius: {
        Value: 125,
        Unit: 'mm',
    },
    Biegeradius_mm: 125,
    FZGleitendMax: {
        Value: 6,
        Unit: 'kg_m',
    },
    H: {
        Value: 130,
        Unit: 'mm',
    },
    H_mm: 130,
    HoeheVorspannung: {
        Value: 130,
        Unit: 'mm',
    },
    HoeheVorspannung_mm: 130,
    Innenbreite: {
        Value: 50,
        Unit: 'mm',
    },
    Innenbreite_mm: 50,
    Innenhoehe: {
        Value: 32,
        Unit: 'mm',
    },
    Innenhoehe_mm: 32,
    K2: {
        Value: 896,
        Unit: 'mm',
    },
    K2_mm: 896,
    LeitungDiameterMax: {
        Value: 9,
        Unit: 'mm',
    },
    LeitungDiameterMax_mm: 9,
    TemperaturMin: {
        Value: -40,
        Unit: '°C',
    },
    TemperaturMin_C: -40,
    TemperaturMax: {
        Value: 120,
        Unit: '°C',
    },
    TemperaturMax_C: 120,
    X1: {
        Value: 400,
        Unit: 'mm',
    },
    X1_mm: 400,
    D1: {
        Value: 175,
        Unit: 'mm',
    },
    D1_mm: 175,
    BeschleunigungGleitendMax: {
        Value: 50,
        Unit: 'm_s2',
    },
    BeschleunigungGleitendMax_m_s2: 50,
    GeschwindigkeitGleitendMax: {
        Value: 10,
        Unit: 'm_s',
    },
    GeschwindigkeitGleitendMax_m_s: 10,
    MaxAELaenge: {
        Value: 154,
        Unit: 'mm',
    },
    MaxAELaenge_mm: 154,
    EntityId: '1',
    Verfahrweg_mm: 63400,
    RinneRef: [],
    MontagesetRef: [],
    LangerWeg: true,
    Einspeisung: KetteEinspeisung_1.KetteEinspeisung.mittigeEinspeisung,
    BelastungFLG: [],
    BelastungFLB: [],
    MinDistKlemmO: { Value: 1, Unit: 'mm' },
    MinDistKlemmU: { Value: 1, Unit: 'mm' },
    MinDistO: { Value: 1, Unit: 'mm' },
    MinDistU: { Value: 1, Unit: 'mm' },
    RastPosDist: { Value: 1, Unit: 'mm' },
    RastPosLeft: { Value: 1, Unit: 'mm' },
    StaticIAArtikelRef: [],
    MinBauraumGleitendRinneRefs: [],
    RinnenvarianteRef: [
        {
            Name: 'FRV Führungsrinne "Super-Alu", "Basic"',
            RinneRef: [3094, 7695],
            MontagesetRef: [2533, 2532, 2534, 2535, 2536, 3096, 2537, 2538, 3098, 3097, 7697, 7696, 7698, 7699, 7700, 7701],
        },
        {
            Name: 'FRV Führungsrinne "Super-Alu", "Heavy Duty"',
            RinneRef: [3094, 7695],
            MontagesetRef: [7704, 7706, 7705, 7707, 7708, 7709, 7710, 7711, 7712, 7713, 7714, 7715, 7716, 7717, 7719, 37184],
        },
        {
            Name: 'FRV Führungsrinnen aus Stahl',
            RinneRef: [7720, 7721],
            MontagesetRef: [3624, 3623, 3625, 3626, 7723, 7722, 3627, 7724, 7725],
        },
        {
            Name: 'ARNV Ablegerinne Typ 01',
            RinneRef: [
                52397, 52396, 54946, 54963, 54962, 54961, 54960, 54959, 54958, 54957, 54956, 54952, 54951, 54950, 54949, 54947,
            ],
            MontagesetRef: [54955, 54954, 54953, 54948],
        },
    ],
    IsMontageMitnehmer: false,
};
exports.rolEchainWithoutAdditionalLinkMock = {
    ArticleType: echain_product_models_1.ArticleType.kette,
    KetteSerieType: KetteSerieType_1.KetteSerieType.rolEchain,
    NumFirstOtherLinks: 3,
    RolLinkRef: 'a.b.2.0',
    StandardLinkRef: 'a.b.2.0',
    RolLink: {
        LinkType: LinkType_1.LinkType.RolLink,
        ArticleType: echain_product_models_1.ArticleType.link,
        ArticleSpecs: [ArticleSpecs_1.ArticleSpecs.rolEchainRolLink],
        ArtNr: {
            DE: 'a.b.1.0',
        },
        ArtNrGenerated: 'a.b.1.0',
        Bezeichnung: {
            'de-DE': 'Rollenglied',
            'en-GB': 'rolLink',
        },
        LangerWeg: true,
        Teilung: { Value: 145, Unit: 'mm' },
        WeightPerLink: { Value: 198.38, Unit: 'g' },
        Innenhoehe: { Value: 1, Unit: 'mm' },
        Innenbreite: { Value: 1, Unit: 'mm' },
        IndexBiegeradius: '1',
        IndexBreite: '01',
        Aussenhoehe: { Value: 1, Unit: 'mm' },
        Aussenbreite: { Value: 1, Unit: 'mm' },
        K2: { Value: 2184, Unit: 'mm' },
        Id: 123456789,
    },
    StandardLink: {
        LinkType: LinkType_1.LinkType.StandardLink,
        ArticleType: echain_product_models_1.ArticleType.link,
        // todo LinkType instead of ArticleSpecs [EKE-11146]
        KetteSerieType: KetteSerieType_1.KetteSerieType.default,
        ArtNr: {
            DE: 'a.b.2.0',
        },
        Bezeichnung: {
            'de-DE': 'Standardglied',
            'en-GB': 'standardLink',
        },
        ArtNrGenerated: 'a.b.2.0',
        Innenhoehe: { Value: 2, Unit: 'mm' },
        Innenbreite: { Value: 2, Unit: 'mm' },
        Aussenhoehe: { Value: 2, Unit: 'mm' },
        Aussenbreite: { Value: 2, Unit: 'mm' },
        Teilung: { Value: 91, Unit: 'mm' },
        K2: { Value: 2184, Unit: 'mm' },
        WeightPerLink: { Value: 91.96, Unit: 'g' },
        Id: 987654321,
        Biegeradius: { Value: 300, Unit: 'mm' },
    },
    Serie: {
        Id: 123,
        KetteSerieType: KetteSerieType_1.KetteSerieType.rolEchain,
        RolEchainCalcByFormula: KettenSerieModel_1.RolEchainCalculationFormulas.Default,
        LangerWegZeichnungsnummer: '12345',
        RolEchainParts: [
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part1a,
                NumKG: 13,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part1b,
                NumKG: 2,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part1c,
                NumKG: 2,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part2,
                NumKG: 6,
                NumRKG: 1,
                NumAKG: 0,
            },
            {
                Name: KettenSerieModel_1.RolEchainPartNames.Part3,
                NumKG: 7,
                NumRKG: 1,
                NumAKG: 0,
            },
        ],
    },
    Verfahrweg: { Value: 63400, Unit: 'mm' },
    Versatz: { Value: 0, Unit: 'mm' },
    ArtNr: {
        DE: 'TODO',
    },
    Id: 50000001,
    Bezeichnung: {},
    LangerWegZeichnungsnummer: '27371',
    BestTyp: 400,
    SerieRef: {
        Id: 9180542665,
        Kuerzel: 'TODO',
    },
    SerienKurzbezeichnung: 'Serie_TODO',
    IndexBreite: '05',
    IndexBiegeradius: '125',
    Halbstegig: false,
    VersatzFestpunktErlaubt: true,
    UngeradeAnzahlGlieder: false,
    GleitenderBetriebErlaubt: true,
    FreigabeEIC: false,
    FreigabeEKE: true,
    FreigabeEKEManualMode: false,
    FreigabeEIQ: true,
    Aussenbreite: {
        Value: 74,
        Unit: 'mm',
    },
    Aussenbreite_mm: 74,
    Aussenhoehe: {
        Value: 54,
        Unit: 'mm',
    },
    Aussenhoehe_mm: 54,
    Bauform: KetteBauform_1.KetteBauform.kette,
    BelastungGleitendMaxWeightUntilSpeed: [[6, 1]],
    Biegeradius: {
        Value: 125,
        Unit: 'mm',
    },
    Biegeradius_mm: 125,
    FZGleitendMax: {
        Value: 6,
        Unit: 'kg_m',
    },
    H: {
        Value: 130,
        Unit: 'mm',
    },
    H_mm: 130,
    HoeheVorspannung: {
        Value: 130,
        Unit: 'mm',
    },
    HoeheVorspannung_mm: 130,
    Innenbreite: {
        Value: 50,
        Unit: 'mm',
    },
    Innenbreite_mm: 50,
    Innenhoehe: {
        Value: 32,
        Unit: 'mm',
    },
    Innenhoehe_mm: 32,
    K2: {
        Value: 896,
        Unit: 'mm',
    },
    K2_mm: 896,
    LeitungDiameterMax: {
        Value: 9,
        Unit: 'mm',
    },
    LeitungDiameterMax_mm: 9,
    TemperaturMin: {
        Value: -40,
        Unit: '°C',
    },
    TemperaturMin_C: -40,
    TemperaturMax: {
        Value: 120,
        Unit: '°C',
    },
    TemperaturMax_C: 120,
    X1: {
        Value: 400,
        Unit: 'mm',
    },
    X1_mm: 400,
    D1: {
        Value: 175,
        Unit: 'mm',
    },
    D1_mm: 175,
    BeschleunigungGleitendMax: {
        Value: 50,
        Unit: 'm_s2',
    },
    BeschleunigungGleitendMax_m_s2: 50,
    GeschwindigkeitGleitendMax: {
        Value: 10,
        Unit: 'm_s',
    },
    GeschwindigkeitGleitendMax_m_s: 10,
    MaxAELaenge: {
        Value: 154,
        Unit: 'mm',
    },
    MaxAELaenge_mm: 154,
    EntityId: '1',
    Verfahrweg_mm: 63400,
    RinneRef: [],
    MontagesetRef: [],
    LangerWeg: true,
    Einspeisung: KetteEinspeisung_1.KetteEinspeisung.mittigeEinspeisung,
    BelastungFLG: [],
    BelastungFLB: [],
    MinDistKlemmO: { Value: 1, Unit: 'mm' },
    MinDistKlemmU: { Value: 1, Unit: 'mm' },
    MinDistO: { Value: 1, Unit: 'mm' },
    MinDistU: { Value: 1, Unit: 'mm' },
    RastPosDist: { Value: 1, Unit: 'mm' },
    RastPosLeft: { Value: 1, Unit: 'mm' },
    StaticIAArtikelRef: [],
    MinBauraumGleitendRinneRefs: [],
    RinnenvarianteRef: [
        {
            Name: 'FRV Führungsrinne "Super-Alu", "Basic"',
            RinneRef: [3094, 7695],
            MontagesetRef: [2533, 2532, 2534, 2535, 2536, 3096, 2537, 2538, 3098, 3097, 7697, 7696, 7698, 7699, 7700, 7701],
        },
        {
            Name: 'FRV Führungsrinne "Super-Alu", "Heavy Duty"',
            RinneRef: [3094, 7695],
            MontagesetRef: [7704, 7706, 7705, 7707, 7708, 7709, 7710, 7711, 7712, 7713, 7714, 7715, 7716, 7717, 7719, 37184],
        },
        {
            Name: 'FRV Führungsrinnen aus Stahl',
            RinneRef: [7720, 7721],
            MontagesetRef: [3624, 3623, 3625, 3626, 7723, 7722, 3627, 7724, 7725],
        },
        {
            Name: 'ARNV Ablegerinne Typ 01',
            RinneRef: [
                52397, 52396, 54946, 54963, 54962, 54961, 54960, 54959, 54958, 54957, 54956, 54952, 54951, 54950, 54949, 54947,
            ],
            MontagesetRef: [54955, 54954, 54953, 54948],
        },
    ],
    IsMontageMitnehmer: false,
};
//# sourceMappingURL=rolEchain.mock.js.map